import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';
import { useAppDispatch } from '../../../hooks/hooks';
import { resetSchoolBankConfigData } from '../../../redux/slices/finance/schoolbankconfig';
import { RootState } from '../../../redux/store';
import { routes } from '../../../routes';
import { createSchoolBankConfig, updateSchoolBankConfig } from '../../../services/finance/schoolBankConfig';
import { SchoolBankConfigType } from '../../../types/Finance';
import { CreateEditSchoolBankConfigFormValidation } from './CreateEditSchoolBankConfigFormValidation';
import SelectComponent from '../../../components/inputs/Select/SelectComponent';
import { SupportedBanks } from '../../../utils/codes';

export const CreateEditSchoolBankConfig = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const isUpdateRoute = location.pathname === routes.updateSchoolBankConfig;

  const dispatch = useAppDispatch();
  const defaultValues = useSelector((state: RootState) => state.schoolbankconfig);

  const mutation = useMutation({ mutationFn: ((defaultValues.id && isUpdateRoute) ? updateSchoolBankConfig : createSchoolBankConfig), mutationKey: "create_edit_SchoolBankConfig" });

  const { control, handleSubmit, formState: { errors }, setValue } = useForm<SchoolBankConfigType>
    (
      {
        resolver: yupResolver(CreateEditSchoolBankConfigFormValidation),
        defaultValues,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
      }
    );

  const onSubmit = handleSubmit(async (data) => {
    try {
      const dataToSend = { ...data, useBankClient: Boolean(data.useBankClient), useBankInstitute: Boolean(data.useBankInstitute) }
      const result = await mutation.mutateAsync(dataToSend);
      if (result) {

        toast.success(`Configuração ${(defaultValues.id && isUpdateRoute) ? 'actualizado' : 'registado'}.`);
        handleBack();
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    dispatch(resetSchoolBankConfigData());
    navigate(routes.getSchoolBankConfig);
  }

  return (
    <Card size='3'>

      <form onSubmit={onSubmit} noValidate>

        <Flex direction='column' gap='4'>

          <Flex gap="8">
            <SelectComponent
              name="bankName"
              label="Banco"
              control={control}
              errors={errors}
              style={{ width: "100%" }}
              options={SupportedBanks?.map((bank) => ({
                value: bank.id ?? "",
                label: bank.description ?? "",
              }))}
              required={true}
            />         
            <TextFieldComponent name="bankDescription" label='Descrição' control={control} errors={errors} fieldProps={{ placeholder: 'Ex: Banco Comercial e de Investimentos' }} style={{ width: '100%' }} />
            <TextFieldComponent name="bankEntity" label='Entidade bancária' control={control} errors={errors} fieldProps={{ placeholder: 'Ex: 123456' }} style={{ width: '100%' }} required={true} />
          </Flex>
          {/* 
          <Flex gap="3">
            <RadioGroupComponent name="useBankClient" label='Usar cliente do banco ?' control={control} errors={errors} style={{ width: '100%' }}
              options={[
                { value: "true", label: "Sim" }
                , { value: "false", label: "Não" }]}
              fieldProps={{
                style: { display: 'flex', flexDirection: 'row', gap: '16px' }
              }}
            />
            <RadioGroupComponent name="useBankInstitute" label='Usar Instituto Banco ?' control={control} errors={errors} style={{ width: '100%' }}
              options={[
                { value: "true", label: "Sim" }
                , { value: "false", label: "Não" }]}
              fieldProps={{
                style: { display: 'flex', flexDirection: 'row', gap: '16px' }
              }}
            />
          </Flex> */}

          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>

            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              {(defaultValues.id && isUpdateRoute) ? 'Actualizar' : 'Registar'}
            </Button>
          </Flex>
        </Flex>
      </form>

    </Card >
  );
}